// extracted by mini-css-extract-plugin
module.exports = {"confirm-buttons":"modals_confirm-buttons__6qnKO","confirm-message":"modals_confirm-message__2w__Z"};